import { Info, Warning, CheckCircle } from 'phosphor-react';
import React, { useEffect, useState } from 'react';

const Notification = ({ type, text, icon, className, children }) => {
  if (!icon) {
    switch (type) {
      case 'error':
      case 'warning':
      case 'info':
        icon = <Warning size={24} />;
        break;

      case 'success':
        icon = <CheckCircle size={24} />;
        break;

      default:
        break;
    }
  }

  const showNotification = () => {
    return type && type != '' && text && text != '';
  };

  return (
    showNotification && (
      <div
        className={`notification ${type ? 'notification--' + type : ''} ${
          className ?? ''
        }`}
      >
        <div className="notification__content-wrapper">
          {icon && <div className="notification__icon-wrapper">{icon}</div>}
          {text}
          {children}
        </div>
      </div>
    )
  );
};

export default Notification;
